import ProductSort from '@components/product/ProductSort'
import {
  GENERAL_FILTER_TITLE,
  PRODUCT_FILTER,
} from '@components/utils/textVariables'

/**
 *
 * {
 *  key: "brandNoAnlz",
 *  value: "Accessorize"
 *  "isSelected": true
 * }
 * */
interface Props {
  products: any
  handleSortBy: any
  routerFilters: any
  clearAll: any
  routerSortOption: any
  swrLoading: any
}

export default function FiltersRightOpen({
  products = { filters: [] },
  handleSortBy,
  routerSortOption,
  swrLoading,
}: Props) {
  return (
    <div className="bg-transparent">
      {/* Mobile filter dialog */}
      <div className="max-w-3xl px-4 text-center sm:px-0 lg:max-w-7xl lg:px-6">
        <section aria-labelledby="filter-heading" className="py-1">
          <h2 id="filter-heading" className="sr-only">
            {PRODUCT_FILTER}
          </h2>

          <div className="flex items-center justify-between">
            <h2 id="filter-heading" className="sr-only">
              {GENERAL_FILTER_TITLE}
            </h2>
            <div className="relative col-start-1 row-start-1 py-4">
              {/* <button
                onClick={clearAll}
                type="button"
                className="text-xs font-semibold text-orange-500 underline uppercase"
              >
                {BTN_CLEAR_ALL}
              </button> */}
            </div>
            <ProductSort
              routerSortOption={routerSortOption}
              products={products}
              action={handleSortBy}
              swrLoading={swrLoading}
            />
          </div>
        </section>
      </div>
    </div>
  )
}
